import { render, staticRenderFns } from "./TrafficLocationTable.vue?vue&type=template&id=622f90b3&"
import script from "./TrafficLocationTable.vue?vue&type=script&lang=js&"
export * from "./TrafficLocationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports